// removed by extract-text-webpack-plugin
module.exports = {"mainWrap":"qempo_OrderViewCommon_mainWrap-i5bEs-G","nonPaddingTop":"qempo_OrderViewCommon_nonPaddingTop-301aBdf","filterWrap":"qempo_OrderViewCommon_filterWrap-OIqs5Bv","rightWrap":"qempo_OrderViewCommon_rightWrap-2O1ovCR","subtitle":"qempo_OrderViewCommon_subtitle-1yCY3Il","ordersWrap":"qempo_OrderViewCommon_ordersWrap-1i_EogV","noResults":"qempo_OrderViewCommon_noResults-2PvFlB_","imageWrap":"qempo_OrderViewCommon_imageWrap-35qSOUx","textWrap":"qempo_OrderViewCommon_textWrap-2QZTor5","loading":"qempo_OrderViewCommon_loading-3DLz0uX"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/orders/components/OrderViewCommon.scss
// module id = 669
// module chunks = 0